<template>
<b-card class="text-center">
    <p class="font-weight-bolder title">{{ title }}</p>
    <b-avatar class="mb-1" :variant="`light-${color}`" size="lg" style="margin-bottom: 0.5em !important;">
        <feather-icon size="20" :icon="icon" />
    </b-avatar>
    <div class="truncate">
        <h5 class="mb-25 font-weight-bolder">
            {{ statistic }}
        </h5>
        <span>{{ statisticTitle }}</span>
    </div>
    <small
        v-if="timestamp"
        class="d-block text-muted mt-50 timestamp-text"
    >
        {{ timestamp }}
    </small>
</b-card>
</template>

<script>
import {
    BCard,
    BAvatar
} from 'bootstrap-vue'

export default {
    components: {
        BCard,
        BAvatar,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
        statistic: {
            type: [Number, String],
            required: true,
        },
        statisticTitle: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: 'primary',
        },
        title: {
            type: String,
            required: true,
        },
        timestamp: {
            type: String,
            default: '',
        },
    },
}
</script>

<style>
.title {
    margin-bottom: 0.5em !important;
    font-size: 8pt;
}

.timestamp-text {
    font-size: 0.7rem;
}


</style>
